import React, { useState } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';

import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.pauls_place} alt='Pauls Place logo' />
      </div>
      <ul className='app__navbar-links'>
        <li className='p__opensans'><a href="#home">Home</a></li>
        <li className='p__opensans'><a href="#about">About</a></li>
        <li className='p__opensans'><a href="#menu">Menu</a></li>
        <li className='p__opensans'><a href="#contact">Contact</a></li>
      </ul>
      <div className='app__navbar-reservations'>
        <a href='https://direct.chownow.com/order/25409/locations/37560?add_cn_ordering_class=true' title='Chownow' className='p__opensans'>Order Online</a>
        <div className='app__navbar-fine-line' />
        <a href='https://www.ezcater.com/catering/pauls-place-steakhouse-3' title='Ezcater' className='p__opensans'>Catering</a>
      </div>
      <div className='app__navbar-smallscreen'>
        <GiHamburgerMenu color='#fff' fontSize={27} className='overlay__open' onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
            <MdOutlineRestaurantMenu fontSize={27} className='overlay__close' onClick={() => setToggleMenu(false)} />
            <ul className='app__navbar-smallscreen_links' onClick={() => setToggleMenu(false)}>
              <li className='p__opensans'><a href="#home">Home</a></li>
              <li className='p__opensans'><a href="#about">About</a></li>
              <li className='p__opensans'><a href="#menu">Menu</a></li>
              <li className='p__opensans'><a href="#contact">Contact</a></li>
            </ul>
            <div className='app__navbar-smallscreen_fine-line' />
            <div className='app__navbar-smallscreen_reservations'>
              <a href='https://direct.chownow.com/order/25409/locations/37560?add_cn_ordering_class=true' title='Chownow' className='p__opensans'>Order Online</a>
              <a href='https://www.ezcater.com/catering/pauls-place-steakhouse-3' title='Ezcater' className='p__opensans'>Catering</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
export default Navbar;
